export const REPORT_LOADING = 'REPORT_LOADING'
export const REPORT_LOADED = 'REPORT_LOADED'
export const REPORT_COMPANIES_LOADED = 'REPORT_COMPANIES_LOADED'
export const REPORT_COMPANY_SELECTED = 'REPORT_COMPANY_SELECTED'
export const REPORT_DETAILS_LOADED = 'REPORT_DETAILS_LOADED'
export const REPORT_DETAILS_NOTFOUND = 'REPORT_DETAILS_NOTFOUND'
export const REPORT_SYNCS_LOADED = 'REPORT_SYNCS_LOADED'
export const REPORT_SYNC_SELECTED = 'REPORT_SYNC_SELECTED'
export const REPORT_SYNC_DATE_SELECTED = 'REPORT_SYNC_DATE_SELECTED'
export const REPORT_SYNC_COMPLETED = 'REPORT_SYNC_COMPLETED';